module.exports = __webpack_public_path__ + "static/img/conveyor-belt-mk-1_256.6590139.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-belt-mk-1_256.png
// module id = yfBy
// module chunks = 0